import { EVENT_SEARCH_MODAL_OPENING } from "../constants";

export default function propagateSearchModalOpen() {
  // Check if we are in the client
  if (typeof window !== "object" || typeof CustomEvent !== "function") {
    console.warn(
      "[Search-ui] Calling search modal open on a server function, ignoring request...",
    );
    return;
  }

  const event = new CustomEvent(EVENT_SEARCH_MODAL_OPENING, {
    detail: {
      timestamp: Date.now(),
    },
  });

  window.dispatchEvent(event);
}
